import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'dineInWaitlist/';

const initialState = {
    waitlist: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchDineInWaitlist = createAsyncThunk(
    'dineInWaitlist/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(API_URL + 'list');
            return res.data.waitlist || [];
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createDineInWaitlistToken = createAsyncThunk(
    'dineInWaitlist/create',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'create', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const callDineInWaitlistToken = createAsyncThunk(
    'dineInWaitlist/call',
    async (waitlistID, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `call/${waitlistID}`);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const seatDineInWaitlistToken = createAsyncThunk(
    'dineInWaitlist/seat',
    async ({ waitlistID, data }, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `seat/${waitlistID}`, data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const cancelDineInWaitlistToken = createAsyncThunk(
    'dineInWaitlist/cancel',
    async (waitlistID, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `cancel/${waitlistID}`);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const printDineInWaitlistToken = createAsyncThunk(
    'dineInWaitlist/print',
    async ({ waitlistID, printerIP, printerPort }, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + `print/${waitlistID}`, { printerIP, printerPort });
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const dineInWaitlistSlice = createSlice({
    name: 'dineInWaitlist',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDineInWaitlist.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchDineInWaitlist.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.waitlist = action.payload;
            })
            .addCase(fetchDineInWaitlist.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createDineInWaitlistToken.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createDineInWaitlistToken.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(createDineInWaitlistToken.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(callDineInWaitlistToken.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(callDineInWaitlistToken.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(callDineInWaitlistToken.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(seatDineInWaitlistToken.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(seatDineInWaitlistToken.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(seatDineInWaitlistToken.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(cancelDineInWaitlistToken.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(cancelDineInWaitlistToken.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(cancelDineInWaitlistToken.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(printDineInWaitlistToken.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(printDineInWaitlistToken.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(printDineInWaitlistToken.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = dineInWaitlistSlice.actions;
export default dineInWaitlistSlice.reducer;